export default __webpack_public_path__ + "static/media/umass-chan-logo.be42c20e.png";